import { render, staticRenderFns } from "./SystemUpdate.vue?vue&type=template&id=49b60a12&"
import script from "./SystemUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports